import { Mode } from '../types/environment'

/**
 * Получаем cdn url в зависимости от окружения
 * @param mode - текущий env окружения
 * @param pipelineId - сгенерированный id в pipeline build
 */
export const getCdnURl = (
  mode: string | undefined,
  pipelineId: string | undefined,
) => {
  /* В development режиме статика локально */
  if (!mode || !pipelineId || mode === Mode.DEVELOPMENT) return ''

  let cdnUrl: string

  switch (mode) {
    case Mode.RC:
      cdnUrl = 'https://static.farfor-rc.ru/site-breed'
      break

    case Mode.PROD:
      cdnUrl = 'https://static.farfor.ru/site-breed'
      break

    default:
      cdnUrl = 'https://static.frfrstaging.ru/site-breed'
      break
  }

  /* Проверка на всякий случай */
  if (cdnUrl) cdnUrl = `${cdnUrl}/${pipelineId}/`

  return cdnUrl
}
